import { useCallback, useEffect, useState } from 'react';
import { fetchPsiPlusHistorialBe, PsiPlusQuarterResultBe, PsiPlusSinBonoBe } from './api/psiPlus';

/**
 * Historial de trimestres PSI+ — GET /psychologist/psi-plus/historial: `trimestres` (ya
 * confirmados/pagados) y `sinBono` (cerrados sin llegar a ningún tramo).
 * Consumido tanto por MetricsPsiPlusTab.tsx (sub-tab "Historial") como por
 * MetricsLiquidacionTab.tsx (tarjeta de bono dentro del período que cierra cada trimestre).
 * Falla silenciosa (sin toast): un trimestre sin confirmar todavía no es un error, es el
 * estado normal la mayor parte del tiempo.
 */
export function usePsiPlusHistorial() {
  const [trimestres, setTrimestres] = useState<PsiPlusQuarterResultBe[]>([]);
  const [sinBono, setSinBono] = useState<PsiPlusSinBonoBe[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const load = useCallback(() => {
    setIsLoading(true);
    fetchPsiPlusHistorialBe()
      .then((resp) => {
        setTrimestres(resp.trimestres);
        setSinBono(resp.trimestresSinBono ?? []);
      })
      .catch(() => {
        setTrimestres([]);
        setSinBono([]);
      })
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { trimestres, sinBono, isLoading, refetch: load };
}
